import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core/styles';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const GreenCheckbox = withStyles({
    root: {
        color: '#95c41f',
        '&$checked': {
            color: '#95c41f',
        }
    },
    checked: {},
  })(props => <Checkbox color="default" {...props} />);

export default function Checkboxes(props) {

    const handleChange = name => event => {
        let res = props.values;
        let i = res.find(a => a.label === name)
        i.checked = !i.checked;
        props.onChange(res);
    };

    return (
        <div>
            <Typography id="range-slider" gutterBottom style={{fontSize: 14}}>
                {props.name}
            </Typography>
            <FormGroup>
                <Grid container spacing={0}>
                    {props.values.map(entry => 
                        <Grid item xs={6} key={entry.label}>
                            <FormControlLabel
                                control={
                                    <GreenCheckbox
                                        icon={<CheckBoxOutlineBlankIcon fontSize="large" />}
                                        checkedIcon={<CheckBoxIcon fontSize="large" />}
                                        checked={entry.checked}
                                        onChange={handleChange(entry.label)}
                                        />
                                }
                                label={<Typography style={{fontSize: 13}}>{entry.label}</Typography>}
                            />
                        </Grid>
                    )}
                </Grid>
            </FormGroup>
        </div>
    );
}